import React from 'react'
import type { BaseHit, Hit } from 'instantsearch.js'

export type AlgoliaSearchResult<T extends BaseHit> = {
  hit: Hit<T>
}

function withResultMapper<
  AlgoliaModel extends BaseHit,
  ResultComponentProps extends object,
>(
  // eslint-disable-next-line no-unused-vars
  mapper: (props: AlgoliaSearchResult<AlgoliaModel>) => ResultComponentProps,
  ResultComponent: React.FC<ResultComponentProps>,
): React.FC<AlgoliaSearchResult<AlgoliaModel>> {
  return (props) => <ResultComponent {...mapper(props)} />
}

export default withResultMapper
